module.exports = __webpack_public_path__ + "img/rule_2.9058e6fe.png";